import { _URL } from "../../config.json";
import http from "../http";

const apiEndpoint = _URL + "/api/Auth/ChangePassword";

export function PostChangePassword(obj) {
  return http.post(apiEndpoint, obj);
}
